import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ClaimByPaymentTokenRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ClaimByPaymentTokenResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const claimByPaymentToken = (request: ClaimByPaymentTokenRequest, options?: CashRequestOptions) =>
  post<ClaimByPaymentTokenRequest, ClaimByPaymentTokenResponse>('/2.0/cash/claim-by-payment-token', request, {
    ...options,
    rejectOnError: true,
  })
